import { RevamppDataAsset } from "../../../../shared/entities/data-asset/revampp-data-asset";
import { getDisplayDate } from "../../../../shared/scripts/date-functions";

export class DataAssetModal {
    viewAssetModalId: string = "view-asset-modal";

    constructor() {

    }

    openModal(dataAsset: RevamppDataAsset) {
        let modal = $(`#${this.viewAssetModalId}`);

        // Header
        let header = modal.find(".modal-header");
        header.empty().html(this.generateHeaderHtml(dataAsset));

        // Body
        let body = modal.find(".modal-body");
        body.empty().html(this.generateBodyHtml(dataAsset));

        // Footer
        let footer = modal.find(".modal-footer");
        footer.empty().html(this.generateFooterHtml(dataAsset));

        this.initializeModal();

        modal.modal("show");
    }

    private initializeModal(): void {
        let modal = $(`#${this.viewAssetModalId}`);
        let body = modal.find(".modal-body");

        // Trigger for show more / read less btns
        body.off("click", ".show-more-btn").on("click", ".show-more-btn", (e) => {
            let target = $(e.currentTarget);
            let siblings = target.siblings(".show-more-text");
            siblings.toggleClass("d-none");
            target.toggleClass("show");
        })
    } 

    private generateHeaderHtml(dataAsset: RevamppDataAsset): string {
        let title = ""
        if (dataAsset.Name) {
            title = `
                <div class="modal-title">
                    ${dataAsset.Name}
                </div>
            `;
        }

        let lastUpdated = `
            <div>
                <span class="font-weight-600">Last Updated</span>: <span>${getDisplayDate(dataAsset.LastModified)}</span>
            </div>
        `;

        let headerHtml = `
            <div>
                ${title}
                ${lastUpdated}
            </div>
            <div>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
        `;

        return headerHtml;
    }

    private generateBodyHtml(dataAsset: RevamppDataAsset): string {
        // Row 1 (Center, Source)
        let centerInfo = `
            <div class="col-12 col-lg-6">
                <div class="modal-subheading">Center</div>
                <div class="row pill-list-container">
                    ${this.generatePillContent(dataAsset.CenterList, "white")}
                </div>
            </div>
        `;

        let displayLink = dataAsset.Source;

        if (dataAsset.Url) {
            displayLink = `<a href="${dataAsset.Url}" target="_blank">${dataAsset.Source}<i class="fa-solid fa-up-right-from-square pl-1"></i></a>`
        }

        let sourceInfo = `
            <div class="col-12 col-lg-6">
                <div class="modal-subheading">Source</div>
                <div class="row pill-list-container">
                    ${this.generatePillContent([displayLink], "yellow")}
                </div>
            </div>
        `;

        let row1 = `
            <div class="row">
                ${centerInfo}
                ${sourceInfo}
            </div>
        `

        // Row 2 (Description) 
        let row2 = "";
        if (dataAsset.Description) {
            let fullText = dataAsset.Description;
            let shortText = dataAsset.Description;
            let showBtn = "";
            let description = `<p class="show-more-text">${fullText}</p>`;


            if (fullText.length > 500) {
                showBtn = `
                    <button type="button" class="btn btn-sm bluebtn py-1 px-2 show-more-btn" style="font-size: 12px; font-weight: 500;">
                        
                    </button>
                `;

                shortText = fullText.substring(0, 500) + "...";
                description = `
                    <p class="show-more-text">${shortText}</p>
                    <p class="show-more-text d-none">${fullText}</p>
                `;
            }

            row2 = `
                <hr />
                <div class="row">
                    <div class="col-12">
                        <div class="modal-subheading">Description</div>
                        ${description}
                        ${showBtn}
                    </div>
                </div>
            `
        };

        // Row 3 (Authors)
        let row3 = "";
        if (dataAsset.AuthorList.length > 0) {
            let tableHeader = `
                <div class="modal-table-header">
                    Name
                </div>
            `;

            let tableRows = "";
            dataAsset.AuthorList.forEach(author => {
                tableRows += `<div class="modal-table-row">${author}</div>`;
            });

            let tableBody = `
                <div class="modal-table-body">
                    ${tableRows}
                </div>
            `;

            row3 = `
                <hr />
                <div class="row">
                    <div class="col-12">
                        <div class="modal-subheading">Contributing Author(s): ${dataAsset.AuthorList.length}</div>
                        <div class="modal-table">
                            ${tableHeader}
                            ${tableBody}
                        </div>
                    </div>
                </div> 
            `;
        };

        // Row 4 (Citations)
        let row4 = "";
        if (dataAsset.PublicationIdList.length > 0) {
            let linkList = [];
            dataAsset.PublicationIdList.forEach(id => {
                let link = `<a href="https://pubmed.ncbi.nlm.nih.gov/${id}/" target="_blank">${id}<i class="fa-solid fa-up-right-from-square pl-1"></i></a>`
                linkList.push(link);
            });

            let citations = `
                <div class="col-12">
                    <div class="modal-subheading">Citations</div>
                    <div class="row pill-list-container">
                        ${this.generatePillContent(linkList, "light-blue")}
                    </div>
                </div>
            `;

            row4 = `
                <hr />
                <div class="row">
                    ${citations}
                </div>
            `
        };

        // Row 5 (Keywords, Search Terms, Etc)
        let row5 = "";
        let row5content = "";
        if (dataAsset.MeasurementTechniqueList.length > 0) {
            let mtContent = this.generateKeywordContent("Measurement Technique", dataAsset.MeasurementTechniqueList);
            row5content += mtContent;
        }
        if (dataAsset.HealthConditionList.length > 0) {
            let hcContent = this.generateKeywordContent("Health Conditions", dataAsset.HealthConditionList);
            row5content += hcContent;
        }
        if (dataAsset.InfectiousAgentList.length > 0) {
            let iaContent = this.generateKeywordContent("Infectious Agent", dataAsset.InfectiousAgentList);
            row5content += iaContent;
        }
        if (dataAsset.SpeciesList.length > 0) {
            let spContent = this.generateKeywordContent("Species", dataAsset.SpeciesList);
            row5content += spContent;
        }
        if (dataAsset.TopicCategoryList.length > 0) {
            let tcContent = this.generateKeywordContent("Topic Category", dataAsset.TopicCategoryList);
            row5content += tcContent;
        }
        if (dataAsset.VariablesMeasuredList.length > 0) {
            let vmContent = this.generateKeywordContent("Variables Measured", dataAsset.VariablesMeasuredList);
            row5content += vmContent;
        }

        if (row5content) {
            row5 = `
                <hr />
                <div class="row">
                    <div class="col-12">
                        <div class="modal-subheading">Search Terms / Metadata</div>
                    </div>
                    ${row5content}
                </div>
            `
        }

        // Return Body

        let bodyHtml = `
            ${row1}
            ${row2}
            ${row3}
            ${row4}
            ${row5}
        `;

        return bodyHtml;
    }

    private generateFooterHtml(dataAsset: RevamppDataAsset): string {
        let closeBtn = `
            <button type="button" class="ml-2 btn btn-secondary btn-sm" data-dismiss="modal">Close</button>
        `;

        let viewBtn = "";
        if (dataAsset.NdeLink) {
            viewBtn = `
                <a href="${dataAsset.NdeLink}" class="btn greenbtn btn-sm text-decoration-none" target="_blank" rel="noopener" style="text-decoration:none;">
                    View in NDE
                </a>
            `;
        }

        let footerHtml = `
            ${viewBtn}
            ${closeBtn}
        `;

        return footerHtml;
    }

    private generatePillContent(strArr: string[], color: string): string {
        if (strArr.length == 0) {
            return "<div class='error-msg col-auto'>--Not Specified--</div>"
        }

        let returnContent = "";
        strArr.forEach(val => {
            returnContent += `
                <div class="col-auto pr-0 mb-2">
                    <div class="pill-list-item ${color}">${val}</div>
                </div>`
        })

        if (returnContent == "") {
            return "<div class='error-msg col-auto'>--Not Specified--</div>";
        }

        return returnContent;
    }

    private generateKeywordContent(title: string, strArr: string[]): string {
        let listContent = "";
        if (strArr.length == 0) {
            listContent = "--Not Specified--";
        }

        strArr.forEach(item => {
            listContent += `<li>${item}</li>`;
        })

        let html = `
            <div class="col-12 col-lg-4">
                <div class="modal-minor-heading">${title}</div>
                <ul class="modal-list">
                    ${listContent}
                </ul>
            </div>
        `;

        return html;
    }
}